<ng-container *ngIf="_line.type === 'tailAmount' || _line.type === 'tailPercentage'; else textLine">
    <div class="calc line row">
        
        <div class="cell spacer" [style.width]="columns['spacer'].width | percent:'1.0-6'"></div>

        <!-- Type -->
        <dropdown-cell #cell class="cell type" [value]="_line | transform: _getType"
            (valueChange)="_HandleChangeType($event)" [items]="_types"
            [column]="columns['type']" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectLeft)="_handleSelectLeft()"
            (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></dropdown-cell>

        <!-- Description -->
        <input-cell #cell class="cell tail description" type="text"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="_tailLine.description"
            [column]="columns['description']" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></input-cell>

        <ng-container *ngIf="_line.type === 'tailAmount'; else percent">
            <!-- Amount (Currency) -->
            <currency-input-cell #cell class="cell amount" (valueChange)="_setPropertyUndo('amount', $event)"
                [value]="_tailLine.amount" [column]="columns['amount']"
                [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
                (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()"
                (selectAbove)="_handleSelectAbove()" (selectBelow)="_handleSelectBelow()"></currency-input-cell>
        </ng-container>
        <ng-template #percent>
            <!-- Amount (Percent) -->
            <input-cell #cell class="cell tail amount" type="percent"
                (valueChange)="_setPropertyUndo('percent', $event)" [value]="_tailLine.percent"
                [column]="columns['amount']" [rowIndex]="index"
                [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
                (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()"
                (selectAbove)="_handleSelectAbove()" (selectBelow)="_handleSelectBelow()"></input-cell>
        </ng-template>

        <!-- Total -->
        <currency-input-cell #cell class="cell total" [column]="columns['total']" [rowIndex]="index" [value]="_line?.aggregation?.all.gross"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></currency-input-cell>
    </div>
</ng-container>
<ng-template #textLine>
    <div class="text line row">
        
        <div class="cell spacer" [style.width]="columns['spacer'].width | percent:'1.0-6'"></div>
        
        <!-- Type -->
        <dropdown-cell #cell class="cell type" [value]="_tailLine | transform: _getType"
            (valueChange)="_HandleChangeType($event)" [items]="_types"
            [column]="columns['type']" [rowIndex]="index" [selection]="selection"
            (selectionChange)="_handleSelectionChange($event)" (selectLeft)="_handleSelectLeft()"
            (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></dropdown-cell>

        <!-- Description -->
        <!-- <input-cell #cell class="cell description" type="text" (valueChange)="_setPropertyUndo('description', $event)"
            [value]="line.description" [column]="columns['description']"
            [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></input-cell> -->
        <multi-line-text-input-cell #cell class="cell description"
            (valueChange)="_setPropertyUndo('description', $event)" [value]="_tailLine.description"
            [column]="columns['description']" [rowIndex]="index"
            [selection]="selection" (selectionChange)="_handleSelectionChange($event)"
            (selectLeft)="_handleSelectLeft()" (selectRight)="_handleSelectRight()" (selectAbove)="_handleSelectAbove()"
            (selectBelow)="_handleSelectBelow()"></multi-line-text-input-cell>

        <!-- Amount -->
        <!-- <div class="cell" [style.width]="columns['amount'].width | percent:'1.0-6'"></div> -->
        <text-cell #cell class="cell" [column]="columns['amount']" [rowIndex]="index" [selection]="selection" (selectionChange)="_handleSelectionChange($event)"></text-cell>

        <!-- Total -->
        <div class="cell" [style.width]="columns['total'].width | percent:'1.0-6'"></div>
    </div>
</ng-template>